<template>
  <v-container fluid class="tp-page">
    <template v-if="!addServico">
      <!-- Cabeçalho -->
      <div class="tp-page-head">
        <div>
          <h1 class="tp-page-title">Serviços</h1>
          <p class="tp-page-sub">{{ tabela.conteudo.length }} no total</p>
        </div>
        <div class="tp-head-actions">
          <v-text-field v-model="tabela.busca" prepend-inner-icon="mdi-magnify" placeholder="Buscar…" hide-details dense outlined color="#00695C" class="tp-search"></v-text-field>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="#00695C" outlined depressed rounded v-on="on" v-bind="attrs" @click="importarPadrao">
                <v-icon left>mdi-download-multiple</v-icon>Importar catálogo padrão
              </v-btn>
            </template>
            <span>Copia a lista de serviços padrão para a sua igreja (não duplica os que já existem)</span>
          </v-tooltip>
          <v-btn color="#00695C" dark depressed rounded class="tp-btn-add" @click="criarNovo">
            <v-icon left>mdi-plus-circle-outline</v-icon>Cadastrar
          </v-btn>
        </div>
      </div>

      <!-- Tabela -->
      <v-card class="tp-card" elevation="0">
        <v-data-table :search="tabela.busca" :headers="tabela.cabecalho" :items="tabela.conteudo" sort-by="nome">
          <template v-slot:[`item.action`]="{ item }">
            <v-icon small class="mr-3" color="#00695C" @click="editItem(item)">edit</v-icon>
            <v-icon small color="error" @click="deleteItem(item)">delete</v-icon>
          </template>
          <template v-slot:no-data>
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Nenhum serviço cadastrado. Clique em "Cadastrar" para começar.</v-alert>
          </template>
          <template v-slot:no-results>
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Sua pesquisa por "{{ tabela.busca }}" não trouxe resultados</v-alert>
          </template>
        </v-data-table>
      </v-card>
    </template>

    <v-card v-else class="tp-card tp-form" elevation="0">
      <v-card-title>
        <span class="tp-serif" style="font-size:1.25rem;color:#00253E;font-weight:600">{{ formTitle }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field v-model="editedItem.nome" outlined label="Nome do serviço" color="#00695C" hide-details
              placeholder="Ex.: Eletricista, Encanador, Advogado"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn color="#00695C" text large @click="close">Cancelar</v-btn>
        <v-btn color="#00695C" dark depressed rounded large class="tp-btn-add px-6" @click="save">Salvar</v-btn>
      </v-card-actions>
    </v-card>

    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { baseApiUrl } from '@/global'
import Snackbar from '../componentes/snackbar.vue'
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  components: { Snackbar, Loading },
  data: () => ({
    fullPage: true,
    isLoading: false,
    addServico: false,
    tabela: {
      busca: '',
      cabecalho: [
        { text: 'Nome', align: 'start', value: 'nome' },
        { text: 'Código', value: 'codigo' },
        { text: 'Ações', value: 'action', align: 'center', sortable: false },
      ],
      conteudo: []
    },
    editedIndex: -1,
    editedItem: { nome: '', codigo: null },
    defaultItem: { nome: '', codigo: null },
  }),

  computed: {
    ...mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),
    formTitle() {
      return this.editedIndex === -1 ? 'ADICIONAR NOVO SERVIÇO' : 'EDITAR SERVIÇO'
    },
  },

  async mounted() {
    await this.carregaServicos();
  },

  methods: {
    async carregaServicos() {
      if (!this.user || !this.user.igrejaId) return;
      try {
        this.isLoading = true;
        const filtro = { where: { igrejaId: this.user.igrejaId }, order: 'nome ASC' };
        const response = await axios.get(`${baseApiUrl}ServicoProfissionals?filter=${encodeURIComponent(JSON.stringify(filtro))}&access_token=${sessionStorage.getItem('accToken')}`);
        this.tabela.conteudo = response.data;
      } catch (error) {
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar serviços.", "ERRO");
      } finally {
        this.isLoading = false;
      }
    },

    // Gera um código estável a partir do nome (usado para vincular os profissionais aos serviços).
    gerarCodigo(nome) {
      let base = (nome || '')
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .toUpperCase().trim()
        .replace(/[^A-Z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');
      if (!base) base = 'SERVICO';
      const existentes = this.tabela.conteudo.map(s => s.codigo);
      let codigo = base;
      let i = 1;
      while (existentes.includes(codigo)) {
        i += 1;
        codigo = `${base}_${i}`;
      }
      return codigo;
    },

    async importarPadrao() {
      if (!this.user || !this.user.igrejaId) return;
      if (!window.confirm('Importar o catálogo de serviços padrão para a sua igreja? Serviços que você já cadastrou não serão duplicados.')) return;
      try {
        this.isLoading = true;
        const response = await axios.post(`${baseApiUrl}ServicoProfissionals/importarPadrao?access_token=${sessionStorage.getItem('accToken')}`, { igrejaId: this.user.igrejaId });
        const criados = (response.data && response.data.criados) || 0;
        if (criados > 0)
          this.$refs.chamaSnackbar.snack("#0288D1", `${criados} serviço(s) importado(s) com sucesso!`, "INFORMAÇÃO");
        else
          this.$refs.chamaSnackbar.snack("#0288D1", "Nenhum serviço novo para importar — o catálogo já está atualizado.", "INFORMAÇÃO");
        await this.carregaServicos();
      } catch (error) {
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao importar catálogo padrão, tente novamente.", "ERRO");
      } finally {
        this.isLoading = false;
      }
    },

    criarNovo() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.addServico = true;
    },

    editItem(item) {
      this.editedIndex = this.tabela.conteudo.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.addServico = true;
    },

    async deleteItem(item) {
      if (!window.confirm(`Excluir o serviço "${item.nome}"? Profissionais vinculados a ele deixarão de aparecer nesse serviço no catálogo.`)) return;
      try {
        this.isLoading = true;
        await axios.delete(`${baseApiUrl}ServicoProfissionals/${item.id}?access_token=${sessionStorage.getItem('accToken')}`);
        this.$refs.chamaSnackbar.snack("#0288D1", "Serviço excluído com sucesso!", "INFORMAÇÃO");
        await this.carregaServicos();
      } catch (error) {
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao excluir serviço, tente novamente.", "ERRO");
      } finally {
        this.isLoading = false;
      }
    },

    close() {
      this.addServico = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async save() {
      const nome = (this.editedItem.nome || '').trim();
      if (!nome) {
        this.$refs.chamaSnackbar.snack("#0288D1", "Informe o nome do serviço.", "INFORMAÇÃO");
        return;
      }

      this.isLoading = true;
      try {
        if (this.editedIndex !== -1 && this.editedItem.id) {
          // Edição: só o nome muda; o código permanece o mesmo para não quebrar o vínculo dos profissionais.
          await axios.patch(`${baseApiUrl}ServicoProfissionals/${this.editedItem.id}?access_token=${sessionStorage.getItem('accToken')}`, { nome });
          this.$refs.chamaSnackbar.snack("#0288D1", "Serviço atualizado com sucesso!", "INFORMAÇÃO");
        } else {
          const novo = { nome, codigo: this.gerarCodigo(nome), igrejaId: this.user.igrejaId };
          await axios.post(`${baseApiUrl}ServicoProfissionals?access_token=${sessionStorage.getItem('accToken')}`, novo);
          this.$refs.chamaSnackbar.snack("#0288D1", "Serviço cadastrado com sucesso!", "INFORMAÇÃO");
        }
        await this.carregaServicos();
        this.close();
      } catch (error) {
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao salvar serviço, tente novamente.", "ERRO");
      } finally {
        this.isLoading = false;
      }
    },
  },
}
</script>

<style>
.theme--light.v-data-table thead tr th {
  color: white;
}
</style>
